<template>
    <div class="container">
        <div class="congratulations">
            <div class="white-box">
                <div class="alignButton">
                        <router-link to="dashboard">
                            <button class="btn btn-secondary w-300px mb-30"> Continue to Dashboard </button>
                        </router-link>
                </div>
                <div class="row">
                    <div class="col-12 col-md-8">
                        <h2>Congratulations!</h2>
                        <div>
                            <p>Dear {{name}},</p>
                            <p class="mb-0">Thank you for registering with us.</p>
                            <p>All of us are delighted to welcome you as a member of the IndiaP2P tribe!</p>
                            <p>We are curating our next batch of investments and will notify you as soon as they are ready. As an early member you will be receiving a special something from us upon your first investment :).</p>
                            <p class="mb-0">Until then, we are always available for a quick chat.</p>
                            <p>You can book an expert session from the calendar link <a target="_blank" rel="noreferrer" href="https://calendly.com/neha-j-1/indiap2p-interview-p1?month=2021-11"><i class="far fa-calendar-alt"></i></a></p>
                            <p>Reach us on whatsapp <a target="_blank" rel="noreferrer" href= "https://wa.me/+919076284367"><i class="fab fa-whatsapp"></i></a></p>
                            <p>To learn more about how IndiaP2P creates high-yield, volatility-free investments, check our blog.</p>
                            <p class="mb-0"><strong>Cheers to your wealth,</strong></p>
                            <p>Neha, Mohit, Ravinder and all of us at IndiaP2P</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 text-right congratulations--img">
                        <img src="/img/congratulations.png" class="img-fluid" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'OnboardingComplete',
    data () {
        return {
            name: ''
        }
    },
    mounted () {
        const isLenderContractSigned = this.$store.state.dashboard.isLenderContractSigned
        if (!isLenderContractSigned) {
            this.$router.replace('/onboarding')
        }
        this.name = this.$store.state.onBoarding.Name
    }
}
</script>
<style lang="scss" scoped>
    @import "~@/sass/components/registration-flow.scss";
    .congratulations {
        padding: 15px;
        @media (min-width: 992px) {
          padding: 60px 30px;
        }
        .white-box {
            padding: 15px;
            @media (min-width: 992px) {
                padding: 24px 60px;

                .btn {
                    width: 300px;
                }

                .alignButton {
                    text-align: right;
                }

            }
        }
        .congratulations--img {
            display: none;
            @media (min-width: 992px) {
                display: block;
            }
        }
    }
    .btn {
        width: 80%;
    }

    .alignButton {
        text-align: center;
    }
    a{
        padding:0px 6px;
    }
</style>
